import { DataTableService } from 'src/app/shared/data-table/data-table.service';
import { TprEmailFilesComponent } from './tpr-email-files/tpr-email-files.component';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { CgpConfirmationDialogService } from '../../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';

import { ToastrService } from 'ngx-toastr';
import { TprChild, TprFilesApiService, TprFolder } from './tpr-show-files-modal.service';
import { LazyLoadEvent, TreeNode } from 'primeng/api/public_api';
import { ColumnDef, PageOptions } from 'src/app/shared/data-table/data-table.interface';
import { TprAddFilesModalComponent } from './tpr-add-files/tpr-add-files-modal.component';
import { filter, map, finalize } from 'rxjs/operators';
import { FileDownloadService } from 'src/app/shared/file-download/file-download.service';
import { UserService } from 'src/modules/user.service';
import { DataTableComponent } from '../../../../../shared/data-table/data-table.component';
import { Router } from '@angular/router';

const folderMappings = {
   'blueBookId': 'BLUE_BOOK',
   'certReportId': 'BUYOFF_DOCUMENTS',
   'jesId': 'JES',
   'avoId': 'AVO',
   'checkFixtStudiesId': 'CHECK_FIXT_STUDIES',
   'necId': 'NEC',
   'acceptedQuoteId': 'ACCEPTED_QUOTE',
   'rejectedQuotesId': 'REJECTED_QUOTE',
   'trashId': 'TRASH'
};

@Component({
   selector: 'tpr-show-files-modal',
   templateUrl: './tpr-show-files-modal.template.html',
   styleUrls: ['../../../tprecm.style.scss']
})
export class TprShowFilesModalComponent implements OnInit {

   selectedFile;
   selectedFileList: number[] = [];
   resourced = false;

   pageOptions: PageOptions = this.dataTableService.pageOptionsDefaultSort('id');

   folders: TreeNode[] = [];
   selection: TreeNode[] = [];

   files: any[];
   total;
   loading = false;
   admSelected = false;
   deleteMessage: any;

   /**
    * Column names and values for the tprFiles table.
    * Matches the DTO.
    *
    * @type {any[]}
    * @memberof TprShowFileModalComponent
    */
   columns: ColumnDef[] = [
      {
         field: 'tprFile', name: 'Tpr File', type: 'link', width: '25em', editable: false, headerHighlight: false,
         callback: (data) =>
            this.download.downloadFile(`tpr/file/${data.id}?tprToolId=${this.data.selectedToolId}`, data.tprFile).subscribe()
      },
      { field: 'recordDate', name: 'Date Added', type: 'date', width: '7em', editable: false, headerHighlight: false, tooltip: 'Date row was added - Read Only' },
   ];

   @ViewChild('tprShowFilesTable') tprShowFilesTable: DataTableComponent;

   constructor(
      private readonly router: Router,
      public dialog: MatDialogRef<TprShowFilesModalComponent>,
      private readonly toastr: ToastrService,
      private readonly tprFileApiService: TprFilesApiService,
      private readonly cgpConfirmationDialogService: CgpConfirmationDialogService,
      private readonly subdialog: MatDialog,
      private readonly download: FileDownloadService,
      private readonly userService: UserService,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private readonly dataTableService: DataTableService
   ) { }

   ngOnInit() {
      if (this.router.url === '/tprecm/view-update-tpr/re-source') {
         this.resourced = true;
         this.columns.forEach(val => { val.editable = false; val.headerHighlight = false; });
      }

      this.tprFileApiService.getFolders()
         .pipe(map((res: TprFolder[]) =>
            res.map(folder => (
               {
                  label: folder.text,
                  icon: 'fa fa-folder-open',
                  data: folder,
                  selectable: false,
                  expanded: true,
                  children: folder.children.map(
                     (child: TprChild) => ({
                        label: child.text,
                        icon: 'fa fa-list',
                        data: child,
                        leaf: child.leaf,
                     })
                  )
               }))))
         .subscribe((res: any) => {
            this.folders = res;

            // Pre-select the first element in the tree
            if (this.folders.length > 0) {
               const first = this.folders
                  .map(node => node.children)
                  .reduce((prev, cur) => prev.concat(cur), [])
                  .find(node => node.leaf);

               this.selection = [first];

               this.loadFiles(first.data.id);
            }
         });
   }

   onTreeSelectionChange(event) {
      const node: TreeNode = event.node;
      this.selection = [node];

      this.columns = this.columns
         .filter(col => col.field !== 'previousFolderName');

      if (node.data.id === 'trashId') {
         this.columns
            .push({ field: 'previousFolderName', name: 'Restore To', width: '5em', editable: false, headerHighlight: false });
      }

      this.loadFiles(node.data.id);
      this.admSelected = this.selection[0].parent.label === 'ADM001' ? true : false;
   }


   loadFiles(folderId: string) {
      this.loading = true;
      this.tprShowFilesTable.selections = [];

      this.tprFileApiService.getTprFiles(folderMappings[folderId], this.data.selectedToolId, this.pageOptions)
         .pipe(finalize(() => this.loading = false))
         .subscribe((response: any) => {
            this.files = response ? response.data : [];
            this.total = response ? response.totalCount : 0;
         }, (err) => {
            this.files = [];
            this.total = 0;
         });

   }

   onGridSelectionChange(event) {
      this.selectedFile = event;
   }

   onLazyLoad(event: LazyLoadEvent) {
      this.pageOptions.order = event.sortOrder === 1 ? 'asc' : 'desc';
      this.pageOptions.size = event.rows;
      this.pageOptions.sort = event.sortField;
      this.pageOptions.page = event.first / this.pageOptions.size;

      this.loadFiles(this.selection[0].data.id);
   }

   onAddFilesClick() {
      const dialogRef = this.subdialog.open(TprAddFilesModalComponent, {
         disableClose: true,
         panelClass: 'tprecm-modal-panel',

         data: {
            selectedFolder: folderMappings[this.selection[0].data.id],
            tprToolId: this.data.selectedToolId
         }
      });

      dialogRef.afterClosed()
         .pipe(filter(Boolean))
         .subscribe(() => this.loadFiles(this.selection[0].data.id));
   }

   onEmailClick() {
      const dialogRef = this.subdialog.open(TprEmailFilesComponent, {
         disableClose: true,

         height: '65vh',
         width: '60vw',
         data: {
            selectedFolder: folderMappings[this.selection[0].data.id],
            tprToolId: this.data.selectedToolId,
            partNumber: this.data.partNumber,
            fixtureNo: this.data.fixtureNo
         }
      });

      dialogRef.afterClosed()
         .pipe(filter(Boolean))
         .subscribe(() => this.loadFiles(this.selection[0].data.id));
   }

   removeHandler() {
      if (this.tprShowFilesTable.selections.length === 0) {
         this.toastr.error('Please select a file.');
         return;
      }
      this.selectedFileList.splice(0, this.selectedFileList.length);

      this.tprShowFilesTable.selections.forEach(data => this.selectedFileList.push(data.id));

      this.cgpConfirmationDialogService.showConfirmationDialog({
         title: 'TPRECM',
         message: `Are you sure you want to delete these files?`,
         alert: 'danger',
         onYesClick: () => {
            this.tprFileApiService.deleteTprFile(this.data.selectedToolId, this.selectedFileList)
               .subscribe({
                  error: err => this.toastr.error('Error deleting: ' + this.selectedFile.tprFile),
                  complete: () => this.loadFiles(this.selection[0].data.id)
               });
            this.tprShowFilesTable.selections = [];
            this.cgpConfirmationDialogService.closeConfirmationDialog();
         },
         onNoClick: () => this.cgpConfirmationDialogService.closeConfirmationDialog()
      });
   }

   trashHandler() {
      if (this.tprShowFilesTable.selections.length === 0) {
         this.toastr.error('Please select a file to trash');
         return;
      }
      this.selectedFileList.splice(0, this.selectedFileList.length);

      this.tprShowFilesTable.selections.forEach(data => this.selectedFileList.push(data.id));

      this.deleteMessage = this.admSelected ? `Are you sure you want to permanently delete these files?` : `Are you sure you want to delete these files?`;

      this.cgpConfirmationDialogService.showConfirmationDialog({
         title: 'TPRECM',
         message: this.deleteMessage,
         alert: 'danger',
         onYesClick: () => {
            if (['acceptedQuoteId', 'rejectedQuotesId'].includes(this.selection[0].data.id)) {
               this.tprFileApiService.deleteTprFile(this.data.selectedToolId, this.selectedFileList)
                  .subscribe({
                     error: err => this.toastr.error('Error deleting: ' + this.selectedFile.tprFile),
                     complete: () => this.loadFiles(this.selection[0].data.id)
                  });
            } else {
               this.tprFileApiService.updateTprFile(this.data.selectedToolId, 'TRASH_BIN', folderMappings[this.selection[0].data.id], this.selectedFileList)
                  .subscribe({
                     error: err => this.toastr.error('Error trashing file(s) '),
                     complete: () => this.loadFiles(this.selection[0].data.id)
                  });
            }

            this.tprShowFilesTable.selections = [];
            this.cgpConfirmationDialogService.closeConfirmationDialog();
         },
         onNoClick: () => this.cgpConfirmationDialogService.closeConfirmationDialog()
      });
   }

   restoreHandler() {
      if (this.tprShowFilesTable.selections.length === 0) {
         this.toastr.error('Please select a file to restore.');
         return;
      }
      this.selectedFileList.splice(0, this.selectedFileList.length);

      this.tprShowFilesTable.selections.forEach(data => this.selectedFileList.push(data.id));

      this.cgpConfirmationDialogService.showConfirmationDialog({
         title: 'TPRECM',
         message: `Are you sure you want to restore these files?`,
         alert: 'danger',
         onYesClick: () => {
            this.tprFileApiService.updateTprFile(this.data.selectedToolId, 'RESTORE', folderMappings[this.selection[0].data.id], this.selectedFileList)
               .subscribe({
                  error: err => this.toastr.error('Error restoring: ' + this.selectedFile.tprFile),
                  complete: () => this.loadFiles(this.selection[0].data.id)
               });
            this.cgpConfirmationDialogService.closeConfirmationDialog();
         },
         onNoClick: () => this.cgpConfirmationDialogService.closeConfirmationDialog(),
      });
   }

   trashFilesEnabled() {
      const selection = this.selection[0];
      const role = this.userService.UserProfile.userRoleId;
      return selection &&
         ((selection.data.id !== 'necId' && selection.data.id !== 'checkFixtStudiesId') || role === 1 || role === 8);
   }


   onUnSelect(dataItem) {
      return dataItem;
   }

}
